import { Link } from "react-router-dom";
import { Instagram, Twitter, Linkedin, Mail, Phone } from "lucide-react";
import { CALENDLY_URL, CONTACT_INFO } from "../data/content";

export const Footer = () => {
  return (
    <footer
      data-testid="main-footer"
      className="relative border-t border-white/10 bg-[#050505] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-display text-2xl md:text-3xl font-black tracking-[0.2em]">
            OBSIDIAN<span className="text-violet-400">.</span>
          </div>
          <p className="mt-4 text-sm text-white/50 max-w-sm leading-relaxed">
            A brand & web design agency for ecommerce brands that refuse to
            blend in. Built in obsidian. Delivered in 3–5 days.
          </p>

          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-book-cta"
            className="mt-6 inline-flex items-center gap-2 px-5 py-3 btn-violet text-xs uppercase tracking-[0.25em] font-semibold"
          >
            Book a Zoom Call
          </a>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-white/40 mb-4">
            Explore
          </div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/portfolio" className="hover:text-white">Portfolio</Link></li>
            <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-white/40 mb-4">
            Reach Out
          </div>
          <ul className="space-y-2 text-sm text-white/70">
            <li className="flex items-center gap-2">
              <Mail size={14} />
              <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-violet-300 transition-colors" data-testid="footer-email">
                {CONTACT_INFO.email}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={14} />
              <a href={`tel:${CONTACT_INFO.phone.replace(/\s/g, "")}`} className="hover:text-violet-300 transition-colors" data-testid="footer-phone">
                {CONTACT_INFO.phone}
              </a>
            </li>
            <li>Mumbai · Bengaluru · Remote</li>
          </ul>
          <div className="flex gap-3 mt-5">
            <a href={CONTACT_INFO.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-9 h-9 border border-white/20 flex items-center justify-center hover:bg-violet-500 hover:border-violet-500 hover:text-white transition-colors" data-testid="footer-social-instagram">
              <Instagram size={15} />
            </a>
            <a href={CONTACT_INFO.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="w-9 h-9 border border-white/20 flex items-center justify-center hover:bg-violet-500 hover:border-violet-500 hover:text-white transition-colors" data-testid="footer-social-twitter">
              <Twitter size={15} />
            </a>
            <a href={CONTACT_INFO.linkedin} target="_blank" rel="noopener noreferrer" aria-label="Linkedin" className="w-9 h-9 border border-white/20 flex items-center justify-center hover:bg-violet-500 hover:border-violet-500 hover:text-white transition-colors" data-testid="footer-social-linkedin">
              <Linkedin size={15} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs text-white/40 tracking-wider">
            © {new Date().getFullYear()} OBSIDIAN MEDIA. All rights reserved.
          </div>
          <div className="text-xs text-white/30 tracking-[0.3em] uppercase">
            Crafted in volcanic glass.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
